import React from "react";
import { useLatest } from "react-use";
export const defaultIsEqual = (a, b) => a === b;
export const defaultIsEqualArray = (a, b) => {
    if (a !== null && b !== null) {
        if (a.length !== b.length)
            return false;
        if (a.some((el, i) => el !== b[i]))
            return false;
        return true;
    }
    else if (a === null && b === null) {
        return true;
    }
    return false;
};
export const useSyncState = (externalState, latestSavedState, isEqual = defaultIsEqual) => {
    const [internalState, setInternalState] = React.useState(externalState);
    const internalStateLatest = useLatest(internalState);
    // change from outside
    React.useEffect(() => {
        if ((latestSavedState.current === undefined ||
            !isEqual(latestSavedState.current, externalState)) &&
            !isEqual(internalStateLatest.current, externalState)) {
            if (latestSavedState.current !== undefined) {
                latestSavedState.current = undefined;
            }
            setInternalState(externalState);
        }
    }, [externalState, isEqual, internalStateLatest, latestSavedState]);
    return [internalState, setInternalState];
};
//# sourceMappingURL=useSyncState.js.map